import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8001'}/api`;

export const PRIVATE_PILOT_MESSAGE = 'Private pilot — access by invitation only';

/**
 * PILOT-ACCESS-002 / 003A: the public, non-secret auth configuration (GET /auth/config).
 *
 * Returns null while unknown (loading, or an older backend without the endpoint), otherwise the
 * server's object. It only shapes the pages: closed signup and disabled invitations are refused
 * by the server itself, whatever the page shows.
 */
export const useAuthConfig = () => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    let active = true;
    axios.get(`${API_URL}/auth/config`)
      .then((response) => {
        if (active && response?.data && typeof response.data === 'object') {
          setConfig(response.data);
        }
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  return config;
};

/** true / false once the server answered with a boolean, otherwise null. */
const usePublicSignup = () => {
  const config = useAuthConfig();
  return typeof config?.public_signup === 'boolean' ? config.public_signup : null;
};

export default usePublicSignup;
